import React, { useEffect } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import PubSub from 'pubsub-js';
import Form from '../../../components/FormContents/index';
import { GET_TITLE_CONTENT_BY_ID } from '../../../queries/titleContent';
import { StatusType } from '../../../enums/status-type.enum';
import {
  EDIT_CONTENT_BY_WRITER_ID,
  ADD_CONTENT_BY_WRITER_ID,
} from '../../../queries/contentWriter';
import { useUserData } from '../../../hooks/context/userUserData.hook';

const TitleContent = (titleId) => {
  return useQuery(GET_TITLE_CONTENT_BY_ID, {
    variables: { id: titleId },
    fetchPolicy: 'network-only',
  });
};

export default function Update({
  titleId,
  setShowDrawer,
  titleStatus,
  refetchContentList,
}) {
  const { data, loading, error } = TitleContent(titleId);
  const [user] = useUserData();

  useEffect(() => {
    if (titleStatus === StatusType.Approved) {
      PubSub.publish('UPDATE-TITLE', {
        titleId,
        status: StatusType.Working,
        writerId: user.id,
      });
    }
  }, [titleId, titleStatus, user.id]);

  const [createContent] = useMutation(ADD_CONTENT_BY_WRITER_ID);
  const [updateContent] = useMutation(EDIT_CONTENT_BY_WRITER_ID);

  if (loading) return 'Loading...';
  if (error) return `Error! ${error.message}`;

  if (data.titleContent.titles[0] && data.titleContent.titles[0].contentId) {
    return (
      <Form
        updateContentMutation={updateContent}
        data={data.titleContent.titles[0]}
        setShowDrawer={setShowDrawer}
        refetchContent={refetchContentList}
        permissions={data.titleContent.permissions}
      />
    );
  }

  return (
    <Form
      updateContentMutation={createContent}
      data={data.titleContent.titles[0]}
      setShowDrawer={setShowDrawer}
      refetchContent={refetchContentList}
      permissions={data.titleContent.permissions}
    />
  );
}
